function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const RESIZE_MODEL_LEVEL = ['horizontal', 'four-corner', 'four', 'eight'];
export class EditorConfig {
  constructor() {
    // 缩放布局, 分别是 8向缩放, 4向(上下左右), 4向(四个角落), 2向水平
    _defineProperty(this, "resizeModel", () => 'eight');
    // 是否等比例缩放
    _defineProperty(this, "uniformScale", () => false);
    // 是否允许平移
    _defineProperty(this, "translatable", () => true);
    // 额外的控制点
    _defineProperty(this, "controlPoints", []);
  }
  merge(other) {
    const next = new EditorConfig();
    const i = RESIZE_MODEL_LEVEL.findIndex(v => v === this.resizeModel());
    const j = RESIZE_MODEL_LEVEL.findIndex(v => v === other.resizeModel());
    // @ts-ignore
    next.resizeModel = () => RESIZE_MODEL_LEVEL[Math.max(i, j)];
    next.uniformScale = this.uniformScale || other.uniformScale;
    next.translatable = () => this.translatable() && other.translatable();
    next.controlPoints = [];
    return next;
  }
}